import React from 'react';

import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import { sum, map } from 'lodash';
import { StringToDouble } from '../../utils';

class PieProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartOptions: {},
    };
  }

  _mapDataToState = () => {
    const _data = this.props.data;
    const seriesData = this._handleMapData(_data);
    const chartOptions = {
      chart: {
        // plotBackgroundColor: null,
        // plotBorderWidth: null,
        // plotShadow: false,
        type: 'pie',
        height: 200,
        spacingLeft: 10,
      },
      title: { text: ' ' },
      credits: {
        enabled: false,
      },
      accessibility: {
        announceNewData: {
            enabled: true
        },
    },
      tooltip: {
        pointFormat: 'Tỷ lệ nắm giữ: <b>{point.percentage:.1f}%</b>',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
            // format: '{point.name}: {point.y:.1f}%'
          },
          showInLegend: false,
          borderWidth: 0,
          colors: [
            '#6558FF',
            '#F7B500',
            '#97D653',
            '#64A5E7',
            '#ED561B',
            '#DDDF00',
            '#24CBE5',
            '#64E572',
            '#FF9655',
          ],
        },
      },
      legend: {
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'middle',
        itemStyle: { color: '#ffffff' },
      },
      series: [
        {
          name: ' ',
          colorByPoint: true,
          innerSize: '30%',
          data: seriesData,
        },
      ],
    };
    this.setState({ chartOptions });
  };

  _handleMapData = (data) => {
    const series = [];
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (index === 0) {
        series.push({
          name: element.name,
          y: StringToDouble(element.value),
          sliced: false,
          selected: true,
        });
      } else {
        series.push({
          name: element.name,
          y: StringToDouble(element.value),
        });
      }
    }

    const _dt = sum(map(data, (o) => StringToDouble(o.value)));
    if (_dt !== 100) {
      const _other = 100 - _dt;
      series.push({
        name: 'Other',
        y: _other,
      });
    }

    console.log(series);
    return series;
  };

  componentWillMount() {
    this._mapDataToState();
  }

  render() {
    return (
      <HighchartsReact
        highcharts={Highcharts}
        options={this.state.chartOptions}
        // containerProps={{ style: { height: '200px' } }}
      />
    );
  }
}

export default PieProfile;
